import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    modal_status: false,
    tipo_filter: null,
    data_etapa: []
};
const mutations = {
    updateField,
    updateLeads: (state, payload) => {
        state.data_etapa = payload;
    }
};
const getters = {
    getField,
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
